import { en } from './en';
import { kk } from './kk';
import { ru } from './ru';
import type { Locale, Translations } from './types';

export const locales: Record<Locale, Translations> = {
  ru,
  kk,
  en,
};

export { en, kk, ru };
